import { render, staticRenderFns } from "./CountryDetails.vue?vue&type=template&id=8c37e0be&scoped=true"
import script from "./CountryDetails.vue?vue&type=script&lang=js"
export * from "./CountryDetails.vue?vue&type=script&lang=js"
import style0 from "./CountryDetails.vue?vue&type=style&index=0&id=8c37e0be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c37e0be",
  null
  
)

export default component.exports